"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SponsoredProjects = void 0;
const GlobalEventName_1 = require("./GlobalEventName");
const PartyName_1 = require("../parties/PartyName");
class SponsoredProjects {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.SPONSORED_PROJECTS;
        this.description = 'All cards with resources on them gain 1 resource. Draw 1 card for each influence.';
        this.revealedDelegate = PartyName_1.PartyName.SCIENTISTS;
        this.currentDelegate = PartyName_1.PartyName.GREENS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            player.getCardsWithResources().forEach((card) => card.resourceCount && player.addResourceTo(card));
            const robotCards = player.getSelfReplicatingRobotsTargetCards();
            robotCards.forEach((card) => {
                if (card.resourceCount > 0) {
                    card.resourceCount++;
                }
            });
            player.drawCard(turmoil.getPlayerInfluence(player));
        });
    }
}
exports.SponsoredProjects = SponsoredProjects;
//# sourceMappingURL=SponsoredProjects.js.map